










import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
})
export default class App extends Vue {
	// components: {
	// 	SiteHeader,
	// 	SiteFooter
	// }

	 beforeCreate(){
        // var _NY = {
        //     HOST: "static-assets.ny.gov",
        //     BASE_HOST: "www.ny.gov",
        //     hideSettings: false,
        //     hideSearch: false
        // };
        // (function (document, bundle, head) {
        //     head = document.getElementsByTagName('head')[0];
        //     bundle = document.createElement('script');
        //     bundle.type = 'text/javascript';
        //     bundle.async = true;
        //     bundle.src = "//static-assets.ny.gov/sites/all/widgets/universal-navigation/js/dist/global-nav-bundle.js";
        //     head.appendChild(bundle);
        // }(document));

    //     let src = '//static-assets.ny.gov/sites/all/widgets/universal-navigation/js/dist/global-nav-bundle.js'
    // let script = document.createElement('script')
    // script.setAttribute('src', src)
    // script.setAttribute('type', 'text/javascript')
    // script.setAttribute('async', 'true')
    // document.head.appendChild(script)
	
	 }

  	public clearStorage(): void {
		localStorage.clear()
		location.reload()
	}

}
